<template>
  <div>
    <titulo-pessoas />

    <filtro @limpar="limparFiltro" @filtrar="getFiltro" />

    <tabela :pessoas="items" @editar="abrirFormulario" @excluir="excluir"  @alterar-ordenacao="novaOrdenacao"/>

    <paginacao
      :total="total"
      v-model="paginacao"
      @input="listar"
    />
  </div>
</template>

<script>
// Utils:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import Permisoes from '@/components/mixins/permissoes';

// Services:
import PessoaService from '@/common/services/pessoa/pessoa.service';

// Components:
import Filtro from './components/Filtro';
import Tabela from './components/Tabela';
import Paginacao from '@/components/paginacao/Paginacao';
import TituloPessoas from '@/views/rh/pessoas/components/TituloPessoas.vue';

export default {
  name: 'Index',
  mixins: [Permisoes],
  components: {
    TituloPessoas,
    Filtro,
    Tabela,
    Paginacao,
  },
  data() {
    return {
      filtrandoPor: '',
      items: [],
      total: 0,
      paginacao: { numeroDaPagina: 1, tamanhoDaPagina: 10 },
      mostrarModalAdicionarPerfis: false,
      item: {},
      botaoHabilitar: true,
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    this.listar();
  },
  methods: {
    getFiltro(buscarPor) {
      this.filtrandoPor = buscarPor;
      this.listar();
    },
    listar(filtro) {
      this.filtrandoPor = filtro === '' ? filtro : this.filtrandoPor;
      this.$store.dispatch(START_LOADING);

      PessoaService.listarPessoas(
        this.filtrandoPor,
        this.paginacao,
        this.campoOrdenado,
        this.ordem)
        .then((result) => {
          this.items = result.data.itens;
          this.total = result.data.paginacao.totalDeElementos;
          this.paginacaoFiltroAtivo = false;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = ordem;
      this.listar(); 
    },
    abrirFormulario(id) {
      id
        ? this.$router.push({ name: 'editar-pessoa', params: { id } })
        : this.$router.push({ name: 'nova-pessoa' });
    },
    excluir(item) {
      const selecionarMsg =
        item.usuario !== null
          ? this.$t('USUARIOS.CONFIRMAR_EXCLUIR_COM_USUARIO')
          : this.$t('PESSOAS.CONFIRMAR_EXCLUIR');

      mensagem
        .confirmacao(null, selecionarMsg.formatUnicorn({ nome: item.nome }))
        .then(async (result) => {
          if (result.value) {
            this.$store.dispatch(START_LOADING);
            PessoaService.excluir(item.id)
              .then(() => {
                mensagem.sucesso(
                  this.$t('GERAL.SUCESSO'),
                  this.$t('PESSOAS.MENSAGEM_EXCLUIDO')
                );
                this.listar();
              })
              .catch((err) => {
                mensagem.showErrors(err);
              })
              .finally(() => {
                this.$store.dispatch(STOP_LOADING);
              });
          }
        });
    },
    // FUNÇÕES MODAL:
    abrirModalAdicionarPerfis(item) {
      this.item = item;
      this.mostrarModalAdicionarPerfis = true;
    },
    fecharModalAdicionarPermissoes() {
      this.item = null;
      this.mostrarModalAdicionarPerfis = false;
    },
    limparFiltro() {
      this.nome = ''
      this.listar();
    }
  },
};
</script>
